export default "__VITE_ASSET__ZjAH54Pd__"